import { Pipe, PipeTransform } from '@angular/core';
import { Role } from '../_models';

@Pipe({
  name: 'role'
})
export class RolesPipe implements PipeTransform {
  public roles = Role;
  transform(value: string): string {
    // Convert Role ID to string (1 = Admin, 2 = Tehnolog...)
    return Object.keys(this.roles)[Object.values(this.roles).indexOf(value)];
  }
}
